module.exports = __webpack_public_path__ + "img/clla_logo_1.55db380f.png";